import React, { useState } from 'react';
import '../../styles/LoginForm.css';
import { Link, useNavigate } from 'react-router-dom';
import { makeLogin } from '../../services/getAllApi';
import Swal from 'sweetalert2'
import { useAuth } from '../../authentication/AuthContext'
import { login_image } from '../../assets';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 

const LoginForm = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      const response = await makeLogin({ email: email, password: password });

      if (response.status === 200) {
        await login(response.data);

        await Swal.fire({
          icon: "success",
          title: "Log In Succesful!",
          showConfirmButton: false,
          timer: 1000
        });
        navigate('/dashboard');

      }
      else {
        await Swal.fire({
          icon: "error",
          title: `${response.response.data.message}!`,
          showConfirmButton: false,
          timer: 1000
        });
      }
    }
    catch (error) {

    }

  };
  const handleForgotPassword = async()=>{
     toast.warn("Please Contact Admin!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
            });
  }

  return (
    <div className='login-container'>
      <div className={`login-subcontainer ${!isLogin ? 'active' : ''}`}>

        <div className={`form-box ${isLogin ? 'login' : 'register'}`}>
          <form onSubmit={handleSubmit}>
            <h1>{isLogin ? 'Administrative Login' : 'Register'}</h1>
            <div className="input-box">
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <i className='bx bxs-user'></i>
            </div>
            <div className="input-box">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <i className='bx bxs-lock-alt'></i>
            </div>
            {!isLogin && (
              <div className="input-box">
                <input type="password" placeholder="Confirm Password" required />
              </div>
            )}
            {isLogin && (
              <div className="forgot-link">
                <a href="#" onClick={handleForgotPassword}>Forgot Password?</a>
              </div>
            )}

            <button type="submit" className="btn">
              Login
            </button>

              <Link to="/">
            <button className="website-btn">
              Go to Website
            <span class="material-symbols-outlined">
            open_in_browser
          </span>
            </button></Link>
            
          </form>
         
        </div>


        <div className="toggle-box">
          <div className="toggle-panel toggle-left">
            {/* <h1 style={{color: "white"}}>Hello, Welcome!</h1> */}
            <div style={{ maxWidth: '28vw' }}>
              <img src={login_image} alt="" />
            </div>

          </div>


        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default LoginForm;
